<template>
  <nav class="admin-navbar shadow-sm px-4 d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <img src="@/assets/logo.png" alt="Logo" class="me-2 logo" />
      <span class="fw-bold brand-text">YellowRoses Admin Panel</span>
    </div>
    <div class="d-flex align-items-center">
      <span class="me-3 text-muted small">Welcome, <strong>{{ email }}</strong></span>
      <button class="btn btn-logout btn-sm" @click="signOut">Logout</button>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters("admin", ["authEmail"]),
    email() {
      return this.authEmail;
    },
  },
  methods: {
    ...mapActions("admin", ["logout"]),
    async signOut() {
      await this.logout();
      this.$router.replace("/admin/login");
    }
  },
};
</script>

<style scoped>
.admin-navbar {
  height: 64px;
  background: #fff;
  border-bottom: 2px solid #f5f0e6;
  font-family: "Poppins", sans-serif;
}

.logo {
  height: 40px;
}

.brand-text {
  color: #c89d43;
  font-size: 1.1rem;
  letter-spacing: 0.3px;
}

.btn-logout {
  background-color: #c89d43;
  color: #fff;
  border: none;
  padding: 6px 14px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.btn-logout:hover {
  background-color: #b0842d;
  transform: translateY(-1px);
}
</style>
